import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';
import { cn } from 'lib/utils';

export const MODULE_CARD_ACCENT_GRADIENT = 'var(--gradient-primary)';

export type ModuleCardProps = {
  title?: React.ReactNode;
  topRightContent?: React.ReactNode;
  children: React.ReactNode;
  block?: boolean;
  centerTitle?: boolean;
  coverImage?: string;
  /**
   * Renders the card on the brand accent gradient.
   *
   * The gradient is light, so content inside keeps the default `text-foreground`
   * for text and icons — white does not survive on it.
   */
  accentBackground?: boolean;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  role?: string;
  tabIndex?: number;
  onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
};

const ModuleCard: React.FC<ModuleCardProps> = ({
  title,
  topRightContent,
  children,
  block = true,
  centerTitle = false,
  coverImage,
  accentBackground = false,
  style,
  bodyStyle,
  onClick,
  role,
  tabIndex,
  onKeyDown,
}) => {
  const accentStyle: React.CSSProperties = accentBackground ? { background: MODULE_CARD_ACCENT_GRADIENT } : {};

  return (
    <Card
      // the cover image bleeds to the card's edges
      className={cn('overflow-hidden', coverImage && 'pt-0', block ? 'w-full' : 'w-fit')}
      style={{ ...accentStyle, ...style }}
      onClick={onClick}
      role={role}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
    >
      {coverImage && <img src={coverImage} alt="" className="block w-full" />}
      {(title || (!centerTitle && topRightContent)) && (
        <CardHeader className={cn('flex flex-row items-start', centerTitle ? 'justify-center' : 'justify-between')}>
          {title && (
            <CardTitle asChild>
              <h2>{title}</h2>
            </CardTitle>
          )}
          {!centerTitle && topRightContent}
        </CardHeader>
      )}
      <CardContent style={bodyStyle}>{children}</CardContent>
    </Card>
  );
};
export default ModuleCard;
